import type { KpiSummary } from '../types'

function Stat({
  label,
  value,
  tone,
}: {
  label: string
  value: number | string
  tone?: 'danger' | 'warning'
}) {
  const valueClass =
    tone === 'danger'
      ? 'text-kumo-danger'
      : tone === 'warning'
        ? 'text-kumo-warning'
        : 'text-kumo-strong'
  return (
    <div className="flex-1 min-w-[140px] rounded-xl border border-kumo-hairline bg-kumo-base px-4 py-3.5">
      <span className="text-xs uppercase tracking-wide font-semibold text-kumo-subtle">
        {label}
      </span>
      <div className={`mt-1.5 text-3xl font-bold ${valueClass}`}>{value}</div>
    </div>
  )
}

export function KPIStrip({ kpis }: { kpis: KpiSummary }) {
  return (
    <div className="flex flex-wrap gap-3.5 mb-6">
      <Stat label="Accounts" value={kpis.total_accounts} />
      <Stat label="Servers" value={kpis.total_servers} />
      <Stat label="Connections" value={kpis.total_connections} />
      <Stat
        label="Blocked"
        value={kpis.blocked_connections}
        tone={kpis.blocked_connections > 0 ? 'danger' : undefined}
      />
      <Stat
        label="Affected Accounts"
        value={kpis.affected_accounts}
        tone={kpis.affected_accounts > 0 ? 'warning' : undefined}
      />
      <Stat
        label="Affected Servers"
        value={kpis.affected_servers}
        tone={kpis.affected_servers > 0 ? 'warning' : undefined}
      />
    </div>
  )
}
